/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 07/05/2025 17:01
 *
 */

import { Routes } from '@angular/router';
import {
  PageChangelogComponent,
  PageMaintenanceComponent,
  PageOauth2LandingComponent,
  PagePwdResetComponent,
  PageResetRequestComponent,
} from '@infodata-group/inf-commons-desktop';
import { dataGuard } from '@monorepo-projects/alwayson-shared';
import { environment } from '../environments/environment';
import { menuGuard } from './guard/menu.guard';

import { authorizationGuardFn } from '@infodata-group/inf-commons';
import { PageLoginAOComponent } from './page/page-login/page-login.component';

export const appRoutes: Routes = [
  { path: 'login', component: PageLoginAOComponent },
  { path: 'reset-request', component: PageResetRequestComponent },
  { path: 'reset-password', component: PagePwdResetComponent },
  {
    path: 'init',
    loadComponent: () => import('./page/page-landing/page-landing.component'),
  },
  { path: 'oauth2', component: PageOauth2LandingComponent },
  {
    path: 'logout',
    loadComponent: () => import('./page/page-logout/page-logout.component'),
  },
  { path: 'maintenance', component: PageMaintenanceComponent },
  {
    path: 'error/:type',
    loadComponent: () => import('./page/page-error/page-error.component'),
  },
  {
    path: 'not-found/:type',
    loadComponent: () => import('./page/page-error/page-error.component'),
  },
  { path: '', redirectTo: 'activity', pathMatch: 'full' },
  {
    path: '',
    loadComponent: () =>
      import('./page/page-container/page-container.component'),
    canActivate: [authorizationGuardFn, dataGuard, menuGuard],
    children: [
      {
        path: 'changelogs',
        component: PageChangelogComponent,
      },
      {
        path: 'activity',
        loadChildren: () => import('./module/activity/activity.routes'),
        data: { preload: true },
      },
      {
        path: 'cartography',
        loadComponent: () =>
          import('./module/cartography/components/wrapper-cartography/wrapper-cartography.component'),
        loadChildren: () => import('./module/cartography/cartography.routes'),
      },
      {
        path: 'report',
        component: null,
        children: [
          {
            path: 'rpj',
            loadChildren: () =>
              import('./module/driver-report/driver-report.routes'),
          },
          {
            path: 'alarms',
            loadChildren: () =>
              import('./module/driver-alarm/driver-alarm.routes'),
          },
          {
            path: 'exception',
            loadChildren: () =>
              import('./module/driver-exception/driver-exception.routes'),
          },
          {
            path: 'geo',
            loadChildren: () =>
              import('./module/driver-geo-search/driver-geo-search.routes'),
          },
          {
            path: 'ecodrive',
            loadChildren: () =>
              import('./module/driver-eco-drive/driver-eco-drive.routes'),
          },
          {
            path: 'check-in',
            loadChildren: () =>
              import('./module/driver-check-in/driver-check-in.routes'),
          },
          {
            path: 'ciaw',
            loadChildren: () =>
              import('./module/driver-ciaw/driver-ciaw.routes'),
          },
          {
            path: 'devices',
            loadChildren: () =>
              import('./module/report-device/report-device.routes'),
          },
        ],
      },
      {
        path: 'material',
        component: null,
        children: [
          {
            path: 'handrail',
            loadChildren: () =>
              import('./module/material-handrail/material-handrail.routes'),
          },
          {
            path: 'report/valued',
            loadChildren: () =>
              import('./module/material-report-valued/material-report-valued.routes'),
          },
          {
            path: 'report/geo',
            loadChildren: () =>
              import('./module/material-geo-search/material-geo-search.routes'),
          },
        ],
      },
      {
        path: 'argea',
        component: null,
        children: [
          {
            path: '',
            loadChildren: () => import('./module/argea/argea.routes'),
          },
        ],
      },
      {
        path: 'gestion',
        component: null,
        children: [
          {
            path: 'fleet',
            loadChildren: () => import('./module/fleet/fleet.routes'),
          },
          {
            path: 'materials',
            loadComponent: () =>
              import('./component/container-gestion/container-gestion.component'),
          },
          {
            path: 'alarms',
            loadChildren: () =>
              import('./module/manage-alarm/manage-alarm.routes'),
          },
          {
            path: 'site',
            loadChildren: () =>
              import('./module/point-of-interest/point-of-interest.routes'),
          },
        ],
      },
      {
        path: 'admin',
        loadChildren: () => import('./module/admin/admin.routes'),
      },
      {
        path: 'preferences',
        loadChildren: () => import('./module/preferences/preferences.routes'),
      },
      {
        path: 'admin-menu-infodata',
        loadChildren: () => import('./module/admin-menu/admin-menu.routes'),
      },
    ],
  },
  {
    path: 'external/:type',
    loadComponent: () => import('./page/page-external/page-external.component'),
  },
];

if (!environment.production) {
  try {
    const route = appRoutes.find(
      (r) => r.path === '' && r.children && r.children.length > 0,
    );
    route.children.push({
      path: 'lab',
      loadChildren: () => import('./module/lab/lab.routes'),
    });
  } catch (e) {
    console.error(e);
  }
}
